// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/metal-printing/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const metalPrintingEN: PageEntry = {
  id: "post.metalldruck",
  locale: "en",
  slug: "metal-printing",
  seo: {
    title: "Glossary: Metal printing explained simply | Dietz GmbH",
    description: "Metal printing refers to a manufacturing process in which metal is pressed or moulded into a specific shape to produce complex parts. In the context of springs, metal printing refe",
  },
  type: "post",
  h1: "Glossary: Metal printing explained simply",
  intro: "Metal printing refers to a manufacturing process in which metal is pressed or moulded into a specific shape to produce complex parts. In the context of springs, metal printing refers to the production of springs by forming metal sheets or wire. This process enables the production of springs with different shapes and geometries. Metal printing offers advantages such as high precision, cost-effective mass production and the ability to realise complex spring designs. Metal printing is an important technique in the production of springs for various applications.",
  blocks: [

  ],
};
